'use strict';

export default {
  paymentModes: {
    singlePayment: 'Paiement unique',
    fixedDates: 'Nombre fixe de versements',
    fixedRecurrence: 'Nombre fixe de versements',
    subscription: 'Abonnement',
    applyDiscount: 'Appliquer un rabais si ce mode est sélectionné',
    addPaymentMode: 'Ajouter un mode de paiement',
    fixedDatesMode: {
      installmentsCount: '{count} versements aux dates suivantes',
    },
    errors: {
      invalidDate: 'Cette date est invalide',
      dateRequired: 'Cette date est obligatoire',
      discountMin: 'Le rabais doit être plus grand ou égal à 0',
      discountMax: 'Le rabais doit être plus petit ou égal à 100',
      installmentMin: 'Le versement doit être plus grand que 0',
      installmentMax: 'Le versement doit être plus petit ou égal à 100',
      installmentsSum: 'La somme des versements doivent être de 100',
      discountValueRequired: 'La valeur du rabais est requise',
    },
  },
};
